import { persistAirlineFromNavigationState } from "../../transport/airlineTransportContext";

interface TransportItem {
  type?: string;
  name?: string;
}

interface NavigateToTransportOptionParams {
  item: TransportItem;
  language: string;
  navigate: (path: string, options?: any) => void;
  state?: any;
}

export const navigateToTransportOption = ({ item, language, navigate, state }: NavigateToTransportOptionParams) => {
  const transportType = item?.type?.toLowerCase();

  if (!transportType) {
    return;
  }

  const path = `/${language}/transport/${transportType}`;
  if (state !== undefined) {
    persistAirlineFromNavigationState(state);
  }
  navigate(path, typeof state === "undefined" ? undefined : { state });
};
